'use client';
import { InitialSelections, ListModelsObjectProps, SelectOptionsProps } from '@/interfaces/filters';
import { createContext, useContext, useState } from 'react';

type Brands = { car?: ListModelsObjectProps; bike?: ListModelsObjectProps };

type LocalStore = {
    initialSelections: InitialSelections;
    title: string;
    brands: Brands;
    isActiveVehicleTypeFilter?: boolean;
    children?: React.ReactNode;
    selectedBrand?: any;
    selectedModel?: any;
    selectedYear?: any;
    selectedVersion?: any;
    selectedStateUF?: any;
    setSelectedBrand: any;
    setSelectedModel: any;
    setSelectedYear: any;
    setSelectedVersion: any;
    setSelectedStateUF: any;
};

const LocalStoreContext = createContext<LocalStore & any>({
    initialSelections: {},
    title: '',
    brands: { car: { list: [], originalList: [] }, bike: { list: [], originalList: [] } },
});

export const LocalStoreProvider = ({
    children,
    initialSelections,
    isActiveVehicleTypeFilter,
    brands,
    title,
}: LocalStore & any) => {
    const [selectedBrand, setSelectedBrand] = useState<SelectOptionsProps | undefined>();
    const [selectedModel, setSelectedModel] = useState<SelectOptionsProps | undefined>();
    const [selectedYear, setSelectedYear] = useState<SelectOptionsProps | undefined>();
    const [selectedVersion, setSelectedVersion] = useState<SelectOptionsProps | undefined>();
    const [selectedStateUF, setSelectedStateUF] = useState<SelectOptionsProps | undefined>();

    return (
        <LocalStoreContext.Provider
            value={{
                initialSelections,
                title,
                isActiveVehicleTypeFilter,
                brands,
                selectedBrand,
                selectedModel,
                selectedYear,
                selectedStateUF,
                selectedVersion,
                setSelectedBrand,
                setSelectedModel,
                setSelectedYear,
                setSelectedVersion,
                setSelectedStateUF,
            }}
        >
            {children}
        </LocalStoreContext.Provider>
    );
};

export const useLocalStore = () => {
    return useContext(LocalStoreContext);
};
